/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";

import styled, {
  SpaceProps,
  TypographyProps,
  LayoutProps,
} from "../../../../../styles";

interface IProps extends SpaceProps, TypographyProps, LayoutProps {}

export const StyledLabel = styled(
  ({ mb, display, fontSize, fontWeight, ...rest }) => <label {...rest} />
)<IProps>`
  display: inline-block;
`;
